// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-statement-container {
  padding: 16px;
  margin: 0;
}

.preview-statement-container img {
  width: 100%;
  height: auto;
  display: block;
  max-width: 100%;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .preview-statement-container {
    padding: 4px !important;
    margin: 0 !important;
    font-size: 0.7rem;
  }
}
@media (max-width: 767px) {
  .preview-statement-container {
    font-size: 0.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/examComponents/PreviewStatement.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAEF;;AAAA;EACE;IACE,uBAAA;IACA,oBAAA;IACA,iBAAA;EAGF;AACF;AADA;EACE;IACE,iBAAA;EAGF;AACF","sourcesContent":[".preview-statement-container {\n  padding: 16px;\n  margin: 0;\n}\n.preview-statement-container img {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-width: 100%;\n}\n@media (min-width: 768px) and (max-width: 1024px) {\n  .preview-statement-container {\n    padding: 4px !important;\n    margin: 0 !important;\n    font-size: 0.7rem;\n  }\n}\n@media (max-width: 767px) {\n  .preview-statement-container {\n    font-size: 0.7rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
